<template>
  <div class="public-form">
    <!-- {{forms}} -->
    <CustomForm :forms="forms" :form_elements="form_elements"/>
  </div>
</template>

<script>
// import Submitting from '@/components/forms/submission/Submitting.vue'
import CustomForm from '@/components/submit_form/CustomForm.vue'
export default {
  name: 'PublicForm',
  components: {
    CustomForm,
  },
  data() {
    return {
      forms: null,
      awaiting_form_data: null,
      form_elements: null,
    }
  },
  mounted() {
    this.getForm(this.$route.params.form_id)
  },
  methods: {
    async getForm(form_id) {
      this.awaiting_form_data = true
      const params = {key:'jd(3.3329djHaiJK3023ld0OD=3'}
      const {forms,form_elements} = await this.$store.dispatch('__forms__',{form_id,params})
      console.log(forms,form_elements)
      this.forms = forms
      this.form_elements = form_elements
      this.awaiting_form_data = false
    },
    // async getForm(id) {
    //   this.awaitFormData = true
    //   const {form,error} = await this.$store.dispatch('_forms', {form_id:id})
    //   this.form = form
    //   console.log(error?.response)
    //   console.log(form)
    //   this.awaitFormData = false
    // },
  }
}
</script>

<style lang="scss" scoped>

</style>